export const postCardDetails = (data) => ({
  type: "CARD_CREATED",
  payload: data,
});


export const openMyQrType = (data) => ({
  type: "OPEN_QR",
  payload: data,
})